'use client'
import { GET_MATCH_ODDS } from '@/graphql/match/match.query'
import { useQuery } from '@apollo/client'
import React, { useState, useEffect, useRef } from 'react'
import Graph from './graph'
import NoData from '../noData'
import Loading from '../loading'
import tableVector from '@/assets/images/error-images/news.svg'

function WinPercentage({ matchDetail }: any) {
  const teamB = matchDetail?.oTeamScoreB?.oTeam
  const teamA = matchDetail?.oTeamScoreA?.oTeam

  const [chartData, setChartData] = useState<any>(null)
  const [transitionIndex, setTransitionIndex] = useState<number | null>(null)
  const [currentTeamId, setCurrentTeamId] = useState(teamA?._id)
  const allData: any = useRef([])
  const teamAPercentage = matchDetail?.oWinPercent[0]?.sWinPercentage
  const teamBPercentage = matchDetail?.oWinPercent[1]?.sWinPercentage
  const tiePercentage = matchDetail?.oWinPercent[2]?.sWinPercentage

  const { data: queryData, loading } = useQuery(GET_MATCH_ODDS, {
    variables: { input: { iMatchId: matchDetail?._id } }
  })

  useEffect(() => {
    if (queryData?.getOddsHistoryByMatchId?.oOddsWinPercentage) {
      allData.current = queryData.getOddsHistoryByMatchId.oOddsWinPercentage
      teamWiseWinPercentage(queryData.getOddsHistoryByMatchId.oOddsWinPercentage, currentTeamId)
    }
  }, [queryData])

  function teamWiseWinPercentage(d: any, teamId: string) {
    // teamWiseWinPercentage
    const getTeamPercentage = (inningData: any, teamId: any) => {
      if (inningData) {
        return inningData?.aWinPercentage?.flatMap((o: any) =>
          o?.aPercent
            ?.map((i: any) => {
              if (i?.iTeamId === teamId) {
                return {
                  d: i?.sWinPercentage,
                  over: o?.sOvers,
                  isWicket: o?.bIsWicket,
                  inning: inningData?.nInningNumber,
                  player: o?.oPlayer?.sFullName ? o?.oPlayer.sFullName : null
                }
              } else return null
            })
            .filter((item: any) => item !== null)
        )
      } else return null
    }

    const inning1Data = d?.find((d: any) => d?.nInningNumber === 1)
    const inning2Data = d?.find((d: any) => d?.nInningNumber === 2)

    const teamAPercentageIn1 = getTeamPercentage(inning1Data, teamA?._id) || []
    const teamAPercentageIn2 = getTeamPercentage(inning2Data, teamA?._id) || []

    const teamBPercentageIn1 = getTeamPercentage(inning1Data, teamB?._id) || []
    const teamBPercentageIn2 = getTeamPercentage(inning2Data, teamB?._id) || []

    const finalTeamAPercentage = [...teamAPercentageIn1, ...teamAPercentageIn2]
    const finalTeamBPercentage = [...teamBPercentageIn1, ...teamBPercentageIn2]

    if (teamId === teamA?._id) {
      mapChartData(finalTeamAPercentage)
    } else if (teamId === teamB?._id) {
      mapChartData(finalTeamBPercentage)
    } else return null
  }

  function mapChartData(data: any) {
    const d = {
      labels: data?.map((d: any) => d?.over),
      datasets: [
        {
          label: 'Win Percentage',
          data: data?.map((data: any) => ({
            x: data.over,
            y: data.d,
            isWicket: data.isWicket,
            inning: data.inning,
            player: data.player
          }))
        }
      ]
    }
    setChartData(d)

    const t: any = d?.datasets[0]?.data
    const transitionIdx = t?.findIndex((point: any, index: number) => {
      return index > 0 && point.inning === 2 && t[index - 1].inning === 1
    })
    setTransitionIndex(transitionIdx)
  }

  function handleTeam(id: string) {
    teamWiseWinPercentage(allData.current, id)
    setCurrentTeamId(id)
  }

  if (loading) return <Loading />
  if (chartData?.datasets[0]?.data?.length === 0) return <NoData imagePath={tableVector} />
  return (
    <>
      <div className="w-full">
        <div className="w-full flex justify-between items-center mb-4">
          <div className="flex w-full gap-3 justify-start items-center">
            <div
              className={`${
                currentTeamId === teamA?._id
                  ? 'bg-primary-500 text-white cursor-default'
                  : 'bg-transparent text-t-origin cursor-pointer'
              } text-center select-none px-3.5 py-2.5 rounded-lg  w-fit border text-base font-bold border-c hover:!bg-primary-500 hover:text-white`}
              onClick={() => handleTeam(teamA?._id)}
            >
              <span className="hidden md:block"> {teamA?.sTitle}</span>
              <span className="md:hidden block"> {teamA?.sAbbr}</span>
            </div>
            <div
              className={`${
                currentTeamId === teamB?._id
                  ? 'bg-primary-500 text-white cursor-default'
                  : 'bg-transparent text-t-origin cursor-pointer'
              } text-center select-none px-3.5 py-2.5 rounded-lg  w-fit border text-base font-bold border-c hover:!bg-primary-500 hover:text-white`}
              onClick={() => handleTeam(teamB?._id)}
            >
              <span className="hidden md:block"> {teamB?.sTitle}</span>
              <span className="md:hidden block"> {teamB?.sAbbr}</span>
            </div>
          </div>
          <div className="px-3 w-full">
            <div className="flex h-2 w-full">
              <div
                className="!bg-primary-500 h-full"
                style={{ width: `${teamAPercentage}%` }}
              ></div>
              <div className="bg-[#D9D9D9] h-full" style={{ width: `${tiePercentage}%` }}></div>
              <div className="!bg-[#888B8C] h-full" style={{ width: `${teamBPercentage}%` }}></div>
            </div>
            {matchDetail?.oWinPercent?.length > 0 && (
              <div className="flex justify-between mt-4">
                <span className="font-medium text-t-700">
                  {matchDetail?.oWinPercent[0]?.sTitle}
                  <span className="text-primary-500 mx-1">{teamAPercentage}%</span>
                </span>
                {tiePercentage && (
                  <span className="font-medium text-t-700">
                    DRAW
                    <span className="mx-1">{tiePercentage}%</span>
                  </span>
                )}
                <span className="font-medium text-t-700">
                  <span className="text-[#888B8C] mx-1">{teamBPercentage}%</span>
                  {matchDetail?.oWinPercent[1]?.sTitle}
                </span>
              </div>
            )}
          </div>
        </div>
        <Graph chartData={chartData} transitionIndex={transitionIndex} />

        <div className="flex gap-4 items-baseline justify-start">
          <div className="flex gap-1 items-center">
            <div className="bg-confirm w-4 h-4 rounded-sm"></div>
            <span>{teamA?.sTitle}</span>
          </div>
          <div className="flex gap-1 items-center">
            <div className="bg-[#888B8C] w-4 h-4 rounded-sm"></div>
            <span>{teamB?.sTitle}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default WinPercentage
